// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BridgeAgreement } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/Bridge';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useBridgeAgreement: () => UseQueryResult<TemplateContract<BridgeAgreement>, string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { bridgeOperator } = useParties();
  return useQuery({
    queryKey: ['queryBridgeAgreement', bridgeOperator, offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryBridgeAgreement(offset!, bridgeOperator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeAgreement;
